import { createContext } from "react";

import { ILocalizedTestElement } from "@/modules/assessments/types/test.interface";

export interface ICurrentPageContext {
  currentPage: number;
  questionsList: ILocalizedTestElement[][];
}

export const CurrentPageContext = createContext<ICurrentPageContext>({
  currentPage: 0,
  questionsList: [],
});
